const getters = {
    timesheet: (state) => state.timesheet,
    timesheetId: (state) =>state.timesheetId,
    timesheetStatus : (state) => state.timesheetStatus,
    loading: state => state.loading
};

export default getters;